import { IOfferSpendByAccountListTableLang } from '../../../types/lang'

export const offerSpendByAccountListTableLang: IOfferSpendByAccountListTableLang = {
	offer_spend_by_account_list_table: {
		column_account_id: 'Account ID_ua',
		column_account: 'Account_ua',
		column_account_in_group: 'Account in Group_ua',
		column_kt_group: 'KT Group_ua',
		column_amount: 'Amount_ua',
		column_date: 'Date_ua',
	}
}